import { sql } from "drizzle-orm";

import type { WsDisplayArtifact } from "@storyboard/web-client";
import { bulkInsert } from "@/db/bulkInsert";
import { displayArtifact } from "@/db/schema";
import { deduplicateByKeyValue } from "@/models/appSyncFunctions.ts";
import { emitTableUpdates } from "@/models/eventing/TableEventManager";

function transformWsDisplayArtifact(r: WsDisplayArtifact) {
  return {
    id: r.id,
    contentId: r.contentId,
    createdAt: r.createdAt,
    deletedAt: r.deletedAt,
    description: r.description,
    title: r.title,
  };
}

export async function bulkUpsertDisplayArtifact(records: WsDisplayArtifact[], deferEmit = false) {
  if (records.length === 0) return;
  const dataSet = records.map((r) => transformWsDisplayArtifact(r));
  const deduped = deduplicateByKeyValue(dataSet, (item) => item.id);
  await bulkInsert(displayArtifact, deduped, {
    onConflict: {
      type: "doUpdate",
      target: [displayArtifact.id],
      set: {
        contentId: sql`"excluded"."contentId"`,
        createdAt: sql`"excluded"."createdAt"`,
        deletedAt: sql`"excluded"."deletedAt"`,
        description: sql`"excluded"."description"`,
        title: sql`"excluded"."title"`,
      },
    },
  });
  if (!deferEmit) {
    emitTableUpdates(["display_artifact"]);
  }
}
